/**
 * Dynamically loads a script and returns a promise
 * @param {string} src - Script URL
 * @param {string} id - Unique identifier for the script tag
 * @returns {Promise<void>}
 */
export const loadScript = (src: string, id: string): Promise<boolean> => {
	return new Promise((resolve, reject) => {
		// Check if script already exists
		if (document.getElementById(id)) {
			resolve(true);

			return;
		}

		const script = document.createElement('script');
		script.id = id;
		script.src = src;
		script.async = true;

		script.onload = () => resolve(true);
		script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

		document.head.appendChild(script);
	});
};

/**
 * Removes a dynamically loaded script
 * @param {string} id - Script ID to remove
 */
export const removeScript = (id: string): void => {
	const script = document.getElementById(id);
	if (script) {
		script.remove();
	}
};
